module.exports = __webpack_public_path__ + "static/media/033.e629b965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/033.jpg
// module id = 540
// module chunks = 0